import axios, { type AxiosError } from 'axios';
import { getCookie } from './cookie';
import { ACCESS_TOKEN_NAME, API_BASE_URL } from './const';
import reissuanceTokenHanlder, {
  CustomAxiosRequestConfig,
} from './reissuanceTokenInterceptor';

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
});

axiosInstance.interceptors.request.use(function (config) {
  const accessToken = getCookie(ACCESS_TOKEN_NAME);
  if (accessToken) {
    config.headers['Authorization'] = `Bearer ${accessToken}`;
  }
  return config;
});

axiosInstance.interceptors.response.use(
  (res) => {
    return res;
  },
  (error: AxiosError<any>) => {
    const originalRequest = error.config as CustomAxiosRequestConfig;
    const errorCode = error.response?.data.errorCode;

    if (
      (errorCode === 'JWT-0001' ||
        errorCode === 'JWT-0002' ||
        errorCode === 'JWT-0003') &&
      !originalRequest._retry
    ) {
      originalRequest._retry = true;
      return reissuanceTokenHanlder(originalRequest);
    }
    return Promise.reject(error);
  },
);

export { axiosInstance };
